/**
 * Checks whether text matches a filter, ignoring case and surrounding whitespace.
 * Unquoted filters match anywhere in the text; filters enclosed in double quotes
 * require an exact match. An empty or whitespace-only filter matches any text.
 *
 * @param text The text to search, or undefined.
 * @param filter The filter to apply, or undefined.
 * @returns Whether the text matches the filter.
 */
export function containsOrExactlyMatches(text: string | undefined, filter: string | undefined): boolean {
    const normalizedFilter = (filter ?? '').trim();
    if (normalizedFilter.length === 0) {
        return true;
    }

    const normalizedText = (text ?? '').trim().toLowerCase();
    // Surrounding double quotes switch from substring matching to exact matching.
    const isExactMatch = normalizedFilter.length >= 2 && normalizedFilter.startsWith('"') && normalizedFilter.endsWith('"');
    const filterValue = (isExactMatch ? normalizedFilter.slice(1, -1) : normalizedFilter).trim().toLowerCase();

    return isExactMatch ? normalizedText === filterValue : normalizedText.includes(filterValue);
};
